import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { LocationGenerator } from './components/LocationGenerator';
import './index.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);
root.render(
  <StrictMode>
    <LocationGenerator />
  </StrictMode>
);
